import request from '@/utils/request'

export const getCPStatistics_web = function(code, type, query) {
  return request({
    url: `/v1/cp168/apis/cpStatistics/${code}/${type}`,
    params: query
  })
}
export const getDailyDragon_web = function(query) {
  return request({
    url: `/v1/cp168/apis/cpStatisticsByStatsType/dailyDragon`,
    params: query
  })
}
export const getHaoMaGuiLu_web = function(query) {
  return request({
    url: `/v1/cp168/apis/cpStatisticsByStatsType/hmGueiLyuStatistics`,
    params: query
  })
}

export const getCpStatisticsByStatsType_web = function(type, query) {
  return request({
    url: `/v1/cp168/apis/cpStatisticsByStatsType/${type}`,
    params: query
  })
}
